<template>
    <div id="doctor-forgot-password-container" class="m-auto">
        <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
                <div class="row">
                    <div class="p-5 w-100">
                        <div class="text-center">
                            <h1 class="h4 text-gray-900 mb-4">
                                <span>{{$t('FORGOTTEN_PASSWORD')}}</span>
                            </h1>
                        </div>
                        <form class="user" @submit.prevent="submitResetEmail">
                            <div class="form-group">
                                <input v-model="email" type="email" class="form-control form-control-user" aria-describedby="emailHelp" :placeholder="$t('EMAIL_ADDRESS')">
                            </div>
                            <button type="submit" class="btn btn-primary btn-user btn-block">{{$t('SEND_PASSWORD_RESET')}}</button>
                            <hr>
                            <div class="d-flex">
                                <router-link class="small" to="login">{{$t('I_KNOW_MY_PASSWORD')}}</router-link>
                            </div>
                        </form>
                        <div  v-if="resultMessage !== ''" class="text-center" role="alert">
                                {{resultMessage}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            email: '',
            resultMessage: ''
        }
    },
    methods: {
        submitResetEmail: function(){
            let self = this
            this.$http.post('/api/auth/forgotten', {
                email: self.email
            })
            .then(response => {
                self.resultMessage = this.$t('PASSWORD_TOKEN_SENT_MESSAGE')
                console.log(response.data)
            })
            .catch(error => {
                console.log(error)
            })
        },
        clearResultMessage: function(){
            this.resultMessage = ''
        }
    },
    watch: {        
        resultMessage: function(value){
            if(value !== ''){
                    setTimeout(() => {
                        this.resultMessage = ''
                }, 7000);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    div{
        span.input-group-text {
            width: 160px;
        }
    }

    #doctor-forgot-password-container {
        max-width: 320px;
    }
</style>
